module.exports = __webpack_public_path__ + "img/spinner.6273021f.png";